import React from 'react'

const DownArrow = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path fill="#0D1536" fillOpacity=".4" d="M16.82 5.369c-.175-.177-.382-.265-.622-.265H3.802c-.24 0-.447.088-.622.265-.176.176-.263.385-.263.627 0 .24.087.45.263.626l6.197 6.238c.176.177.383.265.623.265s.447-.088.623-.265l6.197-6.238c.175-.176.263-.385.263-.627 0-.24-.087-.45-.263-.626z"/>
  </svg>
)

export default DownArrow
